import { css } from '@emotion/core';

export const codeHighlightTokensCss = css`
  /* taken from highlight.js/styles/github.css */
  .hljs-doctag,
  .hljs-keyword,
  .hljs-meta .hljs-keyword,
  .hljs-template-tag,
  .hljs-template-variable,
  .hljs-type,
  .hljs-variable.language_ {
    /* prettylights-syntax-keyword */
    color: var(--color-code-highlight-keyword);
  }
  .hljs-title,
  .hljs-title.class_,
  .hljs-title.class_.inherited__,
  .hljs-title.function_ {
    /* prettylights-syntax-entity */
    color: var(--color-code-highlight-entity);
  }
  .hljs-attr,
  .hljs-attribute,
  .hljs-literal,
  .hljs-meta,
  .hljs-number,
  .hljs-operator,
  .hljs-variable,
  .hljs-selector-attr,
  .hljs-selector-class,
  .hljs-selector-id {
    /* prettylights-syntax-constant */
    color: var(--color-code-highlight-constant);
  }
  .hljs-regexp,
  .hljs-string,
  .hljs-meta .hljs-string {
    /* prettylights-syntax-string */
    color: var(--color-code-highlight-string);
  }
  .hljs-built_in,
  .hljs-symbol {
    /* prettylights-syntax-variable */
    color: var(--color-code-highlight-symbol);
  }
  .hljs-comment,
  .hljs-code,
  .hljs-formula {
    /* prettylights-syntax-comment */
    color: var(--color-code-highlight-comment);
  }
  .hljs-name,
  .hljs-quote,
  .hljs-selector-tag,
  .hljs-selector-pseudo {
    /* prettylights-syntax-entity-tag */
    color: var(--color-code-highlight-tag);
  }
  .hljs-subst {
    /* prettylights-syntax-storage-modifier-import */
    color: var(--color-code-highlight-text);
  }
  .hljs-section {
    /* prettylights-syntax-markup-heading */
    color: var(--color-code-highlight-constant);
    font-weight: bold;
  }
  .hljs-bullet {
    /* prettylights-syntax-markup-list */
    color: var(--color-code-highlight-list);
  }
  .hljs-emphasis {
    /* prettylights-syntax-markup-italic */
    color: var(--color-code-highlight-text);
    font-style: italic;
  }
  .hljs-strong {
    /* prettylights-syntax-markup-bold */
    color: var(--color-code-highlight-text);
    font-weight: bold;
  }
  .hljs-addition {
    /* prettylights-syntax-markup-inserted */
    color: var(--color-code-highlight-added-text);
    background-color: var(--color-code-highlight-added-surface);
  }
  .hljs-deletion {
    /* prettylights-syntax-markup-deleted */
    color: var(--color-code-highlight-removed-text);
    background-color: var(--color-code-highlight-removed-surface);
  }
  .hljs-char.escape_,
  .hljs-link,
  .hljs-params,
  .hljs-property,
  .hljs-punctuation,
  .hljs-tag {
    /* purposely ignored */
  }
`;
